import React from 'react';
import type { EstadoTienda } from '../../types/metas.types';
import { etiquetaEstado, tonoEstado } from '../../utils/estado';
import { CLASES_TONO, cx, TonoPill } from './clases';

interface PillProps {
  tono: TonoPill;
  children: React.ReactNode;
  /** Punto del color del texto antes de la etiqueta (las pastillas de estado lo llevan). */
  punto?: boolean;
  /** Ícono en lugar del punto (p. ej. el triángulo de «2 alertas»). */
  icono?: React.ReactNode;
  title?: string;
  className?: string;
}

/**
 * Pastilla suave (fondo claro, texto oscuro del mismo tono), 24 px de alto y
 * radio 999. Es el `.pill` del diseño.
 */
export const Pill: React.FC<PillProps> = ({ tono, children, punto, icono, title, className }) => (
  <span
    className={cx(
      'inline-flex h-6 items-center gap-1.5 whitespace-nowrap rounded-metas-pill px-2.5 text-xs font-semibold',
      CLASES_TONO[tono],
      className,
    )}
    data-tono={tono}
    title={title}
  >
    {icono ?? (punto && <span aria-hidden="true" className="h-1.5 w-1.5 rounded-full bg-current" />)}
    {children}
  </span>
);

interface EstadoPillProps {
  estado: EstadoTienda | string;
  /** Otro texto para el mismo tono (p. ej. «En captura» en Autorización). */
  texto?: string;
  className?: string;
}

/**
 * El estado de una tienda en la semana, como pastilla: Sin captura y Borrador
 * en gris, Enviada en azul, Autorizada en verde, Rechazada en rojo. Siempre
 * con el nombre: el color nunca va solo.
 */
export const EstadoPill: React.FC<EstadoPillProps> = ({ estado, texto, className }) => (
  <Pill tono={tonoEstado(estado)} punto className={className}>
    {texto ?? etiquetaEstado(estado)}
  </Pill>
);

export default EstadoPill;
